
import { defineComponent, PropType } from 'vue'
import { ToolOutlined } from '@ant-design/icons-vue'
import { SystemMaintenanceConfig } from '@/utils/maintenance'

export default defineComponent({
  name: 'MaintenanceScreen',
  components: { ToolOutlined },
  props: {
    config: { type: Object as PropType<SystemMaintenanceConfig>, required: true },
    checking: { type: Boolean, default: false }
  },
  emits: ['refresh', 'tester']
})
